module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/faq-components/create-faq/create-faq.component.css
// module id = ./src/app/faq-components/create-faq/create-faq.component.css
// module chunks = main